const logo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="Logo_Alpha_copy"
    data-name="Logo Alpha copy"
    viewBox="0 0 2409.39 573.63">
    <defs>
      <linearGradient id="linear-gradient" x1={301.28} x2={301.28} y1={272.76} y2={546.26} gradientUnits="userSpaceOnUse">
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#c6c6c6" />
      </linearGradient>
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-2" x1={714.54} x2={714.54} y1={272.65} y2={352.98} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-3" x1={342.58} x2={342.58} y1={272.8} y2={526.9} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-4" x1={383.88} x2={383.88} y1={272.85} y2={507.52} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-5" x1={425.18} x2={425.18} y1={272.94} y2={488.11} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-6" x1={466.48} x2={466.48} y1={273.12} y2={468.6} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-7" x1={507.77} x2={507.77} y1={273.36} y2={449.03} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-8" x1={503.82} x2={594.32} y1={351.53} y2={351.53} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-9" x1={504} x2={676.74} y1={341.87} y2={341.87} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-10" x1={504.16} x2={759.18} y1={332.21} y2={332.21} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-11" x1={504.38} x2={1008.66} y1={302.99} y2={302.99} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-12" x1={252.24} x2={252.24} y1={272.74} y2={569.24} />
      <linearGradient xlinkHref="#linear-gradient" id="linear-gradient-13" x1={504.26} x2={841.68} y1={322.54} y2={322.54} />
      <style>{".cls-1{fill:none;opacity:.5}.cls-33{fill:#5b5b5b}"}</style>
    </defs>
    <path
      d="M915.06 321.61 92.86 514.25"
      style={{
        opacity: 0.95,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="M656.22 291.21 352.4 362.37"
      style={{
        opacity: 0.3,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="M665.61 292.31 343 367.88"
      style={{
        opacity: 0.45,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m98.09 545.64 406.38-272.25"
      style={{
        stroke: "url(#linear-gradient)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m924.61 352.24-420.14-78.85"
      style={{
        stroke: "url(#linear-gradient-2)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="M504.47 273.39 180.69 526.31"
      style={{
        stroke: "url(#linear-gradient-3)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m504.47 273.39-241.19 233.6"
      style={{
        stroke: "url(#linear-gradient-4)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="M504.47 273.39 345.88 487.66"
      style={{
        stroke: "url(#linear-gradient-5)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m504.47 273.39-75.99 194.94"
      style={{
        stroke: "url(#linear-gradient-6)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m511.08 449.01-6.61-175.62"
      style={{
        stroke: "url(#linear-gradient-7)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m593.67 429.68-89.2-156.29"
      style={{
        stroke: "url(#linear-gradient-8)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m676.27 410.35-171.8-136.96"
      style={{
        stroke: "url(#linear-gradient-9)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m758.87 391.02-254.4-117.63"
      style={{
        strokeLinejoin: "bevel",
        stroke: "url(#linear-gradient-10)",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m504.47 273.39 504.1 59.21"
      style={{
        stroke: "url(#linear-gradient-11)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="M1008.57 332.6 0 568.59"
      style={{
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="M504.47 273.39 0 568.59"
      style={{
        stroke: "url(#linear-gradient-12)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m860.01 315.15-711.94 166.8"
      style={{
        opacity: 0.9,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m223.47 437.82 561.3-131.51"
      style={{
        opacity: 0.8,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="M758.87 302.96 250.32 422.11"
      style={{
        opacity: 0.75,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="M737.75 300.79 272.49 409.13"
      style={{
        opacity: 0.7,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m717.32 298.39-426.23 99.86"
      style={{
        opacity: 0.65,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m701.52 296.53-394.59 92.45"
      style={{
        opacity: 0.6,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m687.89 294.93-367.3 86.06"
      style={{
        opacity: 0.55,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m841.47 371.7-337-98.31"
      style={{
        stroke: "url(#linear-gradient-13)",
        strokeLinejoin: "bevel",
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      d="m676.03 293.54-343.44 80.47"
      style={{
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        opacity: 0.5,
        fill: "none"
      }}
    />
    <path
      d="M817.92 310.2 190.24 457.27"
      style={{
        opacity: 0.85,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        strokeWidth: "1.5px",
        fill: "none"
      }}
    />
    <path
      id="frame_1"
      d="M2241.92 415.12h82.94c11.79 0 21.36-9.61 21.36-21.46V151.51c0-11.85-9.56-21.46-21.36-21.46H383.67c-11.79 0-21.36 9.61-21.36 21.46v242.15c0 11.85 9.56 21.46 21.36 21.46h1693.61"
      data-name="frame 1"
      style={{
        strokeWidth: 2,
        stroke: "#c6c6c6",
        strokeMiterlimit: 10,
        fill: "none"
      }}
    />
    <g id="mydigitalestate" className="cls-1">
      <path
        d="M876.21 284.68v55.54c0 .97-.77 1.74-1.74 1.74h-23.22c-.97 0-1.74-.77-1.74-1.74l.77-65.99-.77-65.99c0-.97.77-1.74 1.74-1.74h35.8c.97 0 1.94.77 2.32 1.55l36.19 97.54 34.06-97.54c.39-.77 1.35-1.55 2.32-1.55h33.48c.97 0 1.74.77 1.74 1.74l-.77 65.99.77 65.99c0 .97-.77 1.74-1.74 1.74h-26.13c-.97 0-1.74-.77-1.74-1.74v-55.54l.97-31.93.19-6.19-33.09 93.86c-.39.77-1.35 1.55-2.32 1.55h-19.74c-.97 0-1.94-.77-2.32-1.55l-36.19-97.54.19 10.26.97 31.54ZM1064.69 373.12c-.39.97-1.35 1.74-2.32 1.74h-24.19c-.77 0-1.55-.77-1.16-1.74l10.45-30.19-40.06-99.09c-.19-.77.39-1.55 1.16-1.55h29.22c.97 0 1.94.77 2.32 1.55l21.68 62.32 18-62.12c.19-.97 1.16-1.74 2.13-1.74h25.93c.97 0 1.55.77 1.16 1.74l-44.32 129.08ZM1121 341.96c-.97 0-1.74-.77-1.74-1.74l.97-65.99-.97-65.99c0-.97.77-1.74 1.74-1.74h47.8c38.9 0 71.8 20.9 71.8 68.7s-33.29 66.77-71.41 66.77H1121Zm28.25-21.87h21.48c21.87 0 39.48-12.97 39.48-45.09s-17.42-46.64-40.25-46.64h-20.71c0 .19-.77 22.84-.77 45.29s.77 46.25.77 46.45ZM1252.98 232.62c-.97 0-1.74-.77-1.74-1.74v-22.64c0-.97.77-1.74 1.74-1.74h25.93c.97 0 1.74.77 1.74 1.74v22.64c0 .97-.77 1.74-1.74 1.74h-25.93Zm0 109.34c-.97 0-1.74-.77-1.74-1.74l.58-47.99-.58-48.19c0-.97.77-1.74 1.74-1.74h26.13c.97 0 1.74.77 1.74 1.74l-.58 48.19.58 47.99c0 .97-.77 1.74-1.74 1.74h-26.13ZM1342.58 380.67c-26.13.39-46.06-10.26-47.61-32.12 0-.97.77-1.74 1.74-1.74h24.96c1.16 0 1.94.77 2.13 1.74 1.35 8.13 7.93 12.97 19.74 12.97 12.58 0 21.29-6.97 21.29-22.64v-11.42c-6.58 8.71-16.26 13.93-28.64 13.93-29.61 0-45.09-21.87-45.09-49.93s16.64-50.51 43.74-50.51c12.39 0 22.06 4.26 28.84 12.19l-.58-9.1c0-.97.77-1.74 1.74-1.74h25.54c.97 0 1.74.77 1.74 1.74l-.39 49.54.19 45.67c0 25.16-16.45 41.41-49.35 41.41Zm-.19-58.25c14.13 0 21.67-10.06 21.87-30.19.19-20.71-7.35-32.13-21.29-32.32-14.71-.39-22.26 10.45-22.26 30.38 0 21.48 7.74 32.32 21.68 32.13ZM1406.64 232.62c-.97 0-1.74-.77-1.74-1.74v-22.64c0-.97.77-1.74 1.74-1.74h25.93c.97 0 1.74.77 1.74 1.74v22.64c0 .97-.77 1.74-1.74 1.74h-25.93Zm0 109.34c-.97 0-1.74-.77-1.74-1.74l.58-47.99-.58-48.19c0-.97.77-1.74 1.74-1.74h26.13c.97 0 1.74.77 1.74 1.74l-.58 48.19.58 47.99c0 .97-.77 1.74-1.74 1.74h-26.13ZM1509.2 338.29c0 .97-.77 1.93-1.55 2.32-5.61 1.94-12 3.29-18.19 3.29-16.84 0-32.9-8.52-32.9-31.16l.19-49.93h-11.22c-.97 0-1.74-.77-1.74-1.74v-17.03c0-.97.77-1.74 1.74-1.74h11.22l-.19-23.22c0-.97.77-1.74 1.74-1.74h25.74c.97 0 1.74.77 1.74 1.74l-.19 23.22h22.06c.97 0 1.74.77 1.74 1.74v17.03c0 .97-.77 1.74-1.74 1.74h-22.26l.19 49.16c0 8.52 4.26 11.22 10.64 11.22 4.64 0 8.32-.77 11.22-1.74.97-.19 1.74.58 1.74 1.35v15.48ZM1587.19 341.96c-.97 0-1.74-.77-1.74-1.74l.39-9.87c-6.97 8.51-16.84 13.55-29.42 13.55-28.25 0-43.16-22.45-43.16-51.48s16.64-52.06 43.74-52.06c12.39 0 22.06 4.45 28.84 12.58l-.58-8.9c0-.97.77-1.74 1.74-1.74h25.93c.97 0 1.74.77 1.74 1.74l-.58 48.19.58 47.99c0 .97-.77 1.74-1.74 1.74h-25.74Zm-22.64-17.42c14.13 0 21.67-10.64 21.87-31.74.19-21.29-7.35-32.9-21.29-33.09-14.71-.39-22.26 10.64-22.26 31.16 0 22.45 7.74 33.87 21.68 33.67ZM1629.18 341.96c-.97 0-1.74-.77-1.74-1.74l.77-65.99-.77-65.99c0-.97.77-1.74 1.74-1.74h25.35c.97 0 1.74.77 1.74 1.74l-.77 65.99.77 65.99c0 .97-.77 1.74-1.74 1.74h-25.35ZM1671.75 341.96c-.97 0-1.74-.77-1.74-1.74l.97-65.99-.97-65.99c0-.97.77-1.74 1.74-1.74h91.34c.97 0 1.74.77 1.74 1.74v18.39c0 .97-.77 1.74-1.74 1.74H1700l-.77 31.16h58.25c.97 0 1.74.77 1.74 1.74v18.39c0 .97-.77 1.74-1.74 1.74h-58.25l.77 38.71h64.64c.97 0 1.74.77 1.74 1.74v18.38c0 .97-.77 1.74-1.74 1.74h-92.89ZM1820.37 344.28c-29.03 0-47.61-11.8-48.58-34.06 0-.97.77-1.74 1.74-1.74h24.77c.97 0 1.74.77 1.74 1.74.77 11.22 8.13 16.06 21.67 16.06 11.42 0 17.61-4.45 17.61-12.19 0-18.97-65.22-.58-65.22-42.38 0-20.71 16.64-31.74 43.54-31.74s43.74 10.45 45.48 31.35c.19.97-.58 1.74-1.55 1.74h-23.61c-.97 0-1.74-.77-1.94-1.74-1.55-8.51-6.97-13.74-18.77-13.74-9.48 0-15.48 3.48-15.48 12 0 18.97 65.22-.39 65.22 42 0 20.9-19.74 32.71-46.64 32.71ZM1935.13 338.29c0 .97-.77 1.93-1.55 2.32-5.61 1.94-12 3.29-18.19 3.29-16.84 0-32.9-8.52-32.9-31.16l.19-49.93h-11.22c-.97 0-1.74-.77-1.74-1.74v-17.03c0-.97.77-1.74 1.74-1.74h11.22l-.19-23.22c0-.97.77-1.74 1.74-1.74h25.74c.97 0 1.74.77 1.74 1.74l-.19 23.22h22.06c.97 0 1.74.77 1.74 1.74v17.03c0 .97-.77 1.74-1.74 1.74h-22.26l.19 49.16c0 8.52 4.26 11.22 10.64 11.22 4.64 0 8.32-.77 11.22-1.74.97-.19 1.74.58 1.74 1.35v15.48ZM2016.99 341.96c-.97 0-1.74-.77-1.74-1.74l.39-9.87c-6.97 8.51-16.84 13.55-29.42 13.55-28.25 0-43.16-22.45-43.16-51.48s16.64-52.06 43.74-52.06c12.39 0 22.06 4.45 28.84 12.58l-.58-8.9c0-.97.77-1.74 1.74-1.74h25.93c.97 0 1.74.77 1.74 1.74l-.58 48.19.58 47.99c0 .97-.77 1.74-1.74 1.74h-25.74Zm-22.64-17.42c14.13 0 21.67-10.64 21.87-31.74.19-21.29-7.35-32.9-21.29-33.09-14.71-.39-22.26 10.64-22.26 31.16 0 22.45 7.74 33.87 21.68 33.67ZM2122.46 338.29c0 .97-.77 1.93-1.55 2.32-5.61 1.94-12 3.29-18.19 3.29-16.84 0-32.9-8.52-32.9-31.16l.19-49.93h-11.22c-.97 0-1.74-.77-1.74-1.74v-17.03c0-.97.77-1.74 1.74-1.74h11.22l-.19-23.22c0-.97.77-1.74 1.74-1.74h25.74c.97 0 1.74.77 1.74 1.74l-.19 23.22h22.06c.97 0 1.74.77 1.74 1.74v17.03c0 .97-.77 1.74-1.74 1.74h-22.26l.19 49.16c0 8.52 4.26 11.22 10.64 11.22 4.64 0 8.32-.77 11.22-1.74.97-.19 1.74.58 1.74 1.35v15.48ZM2227.92 308.29c.97 0 1.74.77 1.55 1.74-2.52 18.19-19.93 34.45-47.8 34.45-33.29 0-51.29-21.87-51.29-52.06 0-31.74 18.97-52.64 50.7-52.64s50.9 21.67 51.48 56.51c0 .97-.77 1.74-1.74 1.74h-71.22c1.16 18.77 8.52 27.09 22.45 27.09 9.68 0 16.64-4.45 19.35-15.09.19-.97 1.16-1.74 2.13-1.74h24.38Zm-46.64-49.35c-11.61 0-18.58 6.97-20.9 20.71h40.83c-1.16-10.64-7.16-20.71-19.93-20.71Z"
        className="cls-33"
      />
    </g>
    <path
      id="graph_1"
      d="M385.42 279.32h51.02c11.73 0 21.26 9.53 21.26 21.26v114.54h-72.28c-11.73 0-21.26-9.53-21.26-21.26v-93.28c0-11.73 9.53-21.26 21.26-21.26Z"
      data-name="graph 1"
      style={{
        fill: "rgba(217,218,219,.3)",
        stroke: "#8e8e8e",
        strokeWidth: 5,
        strokeMiterlimit: 10
      }}
    />
    <path
      id="graph_2"
      d="M526.54 415.12H457.7V214c0-11.74 9.52-21.26 21.26-21.26h51.02c11.74 0 21.26 9.52 21.26 21.26v192.86"
      data-name="graph 2"
      style={{
        stroke: "#8e8e8e",
        strokeWidth: 5,
        fill: "rgba(184,186,188,.3)",
        strokeMiterlimit: 10
      }}
    />
    <path
      id="graph_3"
      d="M551.24 406.85V152.91c0-11.74 9.52-21.26 21.26-21.26h51.02c11.74 0 21.26 9.52 21.26 21.26v224.32"
      data-name="graph 3"
      style={{
        fill: "rgba(153,153,153,.3)",
        stroke: "#8e8e8e",
        strokeWidth: 5,
        strokeMiterlimit: 10
      }}
    />
    <g id="disk">
      <path
        d="M294.75 479.45c-39.09 0-63.42-7.06-66.76-19.37-1.55-5.71-.35-21.8 44.05-47.79 22.02-12.89 52.95-26.8 89.61-40.33v1.13c-19.27 8.23-34.68 16.19-45.82 23.65-17.09 11.45-24.43 21.61-21.81 30.21 4.08 13.41 31.29 16.23 53.41 16.23h.02c39.04 0 95.13-8.31 162.19-24.02 65.54-15.36 120.51-32.86 158.95-50.62 24.79-11.45 54.26-28.39 53.91-44.09-.24-10.53-13.54-15.23-24.65-17.32-8.2-1.54-18.63-2.32-31.02-2.32-6.19 0-12.92.2-20.04.58v-.38c22.04-2.23 41.94-3.35 59.19-3.35 11.84 0 22.43.54 31.48 1.6 26.9 3.16 42.69 11.24 43.31 22.17.82 14.42-22.52 34.15-64.01 54.13-49.51 23.84-123.35 47.6-213.52 68.7-87.18 20.4-159.27 31.18-208.48 31.18Z"
        style={{
          fill: "#848484",
          opacity: 0.3
        }}
      />
      <path
        d="M705.98 304.17c11.74 0 22.23.53 31.19 1.58 25.2 2.96 40.57 10.37 41.1 19.83.33 5.88-4.39 13.34-13.66 21.55-10.84 9.61-27.31 19.77-48.94 30.19-49.35 23.77-123.01 47.46-213.01 68.52-87 20.36-158.89 31.12-207.91 31.12-37.32 0-61.37-6.55-64.35-17.53-1.65-6.08 3.36-13.38 7.86-18.43 7.44-8.35 19.23-17.28 35.04-26.54 12.55-7.34 28.01-15.02 45.81-22.78-1.63 1.01-3.18 2.01-4.66 3-18.11 12.13-25.78 23.24-22.81 33.02 3.63 11.94 22.41 18 55.82 18 39.22 0 95.5-8.33 162.76-24.09 65.71-15.39 120.84-32.95 159.43-50.78 37.04-17.11 55.66-32.73 55.36-46.42-.27-12.21-14.67-17.46-26.69-19.72-.73-.14-1.48-.27-2.25-.39 3.4-.08 6.7-.12 9.92-.12m0-5c-18.42 0-39.37 1.28-61.69 3.6v5.28c7.98-.48 15.53-.73 22.54-.73 11.93 0 22.29.72 30.57 2.28 61.25 11.5-2.02 63.49-188.31 107.14-72.09 16.89-126.05 23.96-161.62 23.96-56.12 0-66.48-17.57-30.22-41.86 11.69-7.83 27.89-16.01 46.92-24.07v-6.37c-36.46 13.3-69.27 27.64-93.38 41.75-64.9 37.98-63.93 71.82 23.97 71.82 45.46 0 114.16-9.05 209.05-31.25 278.65-65.2 332.36-138.36 233.95-149.92-9.37-1.1-20.06-1.62-31.77-1.62Z"
        style={{
          fill: "#8e8e8e"
        }}
      />
    </g>
    <g className="cls-1">
      <path
        d="M2121.74 428.49c-1.16.67-2.44 1.22-4.33 1.22-3.23 0-4.58-2.01-5.12-5.8-1.95 3.66-5 5.8-9.33 5.8-7.14 0-12.26-6.65-12.26-14.58s5.12-14.64 12.38-14.64c4.45 0 7.2 2.38 8.91 5.61.06-1.53.24-3.42.49-5.06h6.47c-.55 3.29-.98 7.75-.98 12.32v6.16c0 3.66.98 4.58 2.44 4.58.55 0 .85-.12 1.34-.3v4.7Zm-24.04-33.43c1.59-.06 2.87-.98 2.87-2.38 0-1.1-.92-2.01-2.32-2.01-.85 0-1.59.18-2.26.73v-3.9c.98-.37 1.89-.55 3.05-.55 3.84 0 6.41 2.26 6.41 5.55 0 3.66-3.05 6.16-7.75 6.22v-3.66Zm7.14 11.16c-4.09 0-7.14 4.03-7.14 8.85s3.17 8.91 7.26 8.91c3.84 0 6.83-3.66 6.83-8.91s-2.99-8.85-6.96-8.85Zm5.98-19.52h5.98l-5 10.55h-5.25l4.27-10.55ZM2123.75 384.75c1.65-.37 2.62-.98 5.31-.98 6.04 0 9.27 3.66 12.87 12.57l10 24.77c1.04 2.44 2.62 5.86 3.72 7.87h-8.54c-.3-1.71-.98-3.84-1.65-5.67l-5.18-13.6-7.02 16.29c-.43.98-.98 2.01-1.22 2.99h-7.02c.79-1.04 1.46-2.13 2.38-4.03l10.13-22.02-2.07-5.12c-2.32-6.1-4.7-7.99-7.87-8.05-1.28 0-2.56.37-3.84.92v-5.92ZM2173.29 442.4c.18-1.4.24-4.21.24-6.28v-6.65c-8.85-.79-15.07-6.34-15.07-14.76s6.22-13.91 15.07-14.7v-4.64c0-1.89-.06-4.82-.24-6.28h6.34c-.18 1.46-.18 4.33-.18 6.28l-.06 4.64c8.78.79 15.01 6.34 15.01 14.7s-6.41 14.03-15.01 14.76l.06 6.65c0 2.26.06 4.88.24 6.28h-6.41Zm.24-36.54c-4.58.18-8.48 3.36-8.48 8.85s3.9 8.72 8.48 8.97v-17.81Zm5.86 17.81c4.58-.24 8.48-3.42 8.48-8.97s-3.9-8.66-8.48-8.85v17.81ZM2231.24 428.49c-1.16.67-2.44 1.22-4.33 1.22-3.23 0-4.58-2.01-5.12-5.8-1.95 3.66-5 5.8-9.33 5.8-7.14 0-12.26-6.65-12.26-14.58s5.12-14.64 12.38-14.64c4.45 0 7.2 2.38 8.91 5.61.06-1.53.24-3.42.49-5.06h6.47c-.55 3.29-.98 7.75-.98 12.32v6.16c0 3.66.98 4.58 2.44 4.58.55 0 .85-.12 1.34-.3v4.7Zm-16.9-22.27c-4.09 0-7.14 4.03-7.14 8.85s3.17 8.91 7.26 8.91c3.84 0 6.83-3.66 6.83-8.91s-2.99-8.85-6.96-8.85Z"
        className="cls-33"
      />
    </g>
  </svg>
)
export default logo
